<template>
  <div>
    <CardComponent ref="card" variant="tertiary">
      <template #header>
          <div class="card-title header_title">
            <span class="material-symbols-outlined"> key </span>
            <span> {{ $t("generic-str.key-word") }}</span>
          </div>
          <div class="opts_card">
            <!-- <button class="btn" v-modal="{ target: 'create-key-modal' }">
              <span class="material-icons add_person"> add </span>
            </button> -->
            <button class="btn" :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              @click="deleteMultiple" v-bind:disabled="selectedKeywords.length == 0 || isSending">
              <span class="material-symbols-outlined title"> delete_forever </span>
            </button>
            <!-- <span class="material-icons-outlined title"> file_upload </span>
            <i class="fas fa-file-export title"></i> -->
          </div>
      </template>
      <div class="keyword-wrapper">
        <div class="col-lg-12 p-0">
          <div v-if="!keywords.length && fetched" class="card-body">
            <LottieAnimNoData />
            <h5 class="card-title m-t-20">Nenhuma palavra chave cadastrada</h5>
          </div>
          <div class="card-body" v-if="fetched">
            <div class="mb-4">
              <button type="button" class="btn p-0 icon_btn m-0 mr-2" @click="showKeywords">
                <span class="material-symbols-outlined purple-add"> add </span>
              </button>
              <span class="text-yup" style="font-weight: 400">{{ $t("generic-str.add") }} {{ $t("generic-str.key-word")
              }}</span>
            </div>
            <div v-if="keywords.length" class="keywords-wrapper">
              <ul class="list-unstyled mb-3 list-options">
                <li class="mb-4">
                  <div class="control-group opt-2">
                    <label class="control control-checkbox" for="check-all-keywords"><input id="check-all-keywords"
                        v-model="selectAllKeywords" type="checkbox" />
                      <div class="control_indicator"></div>
                      <span>{{ $t("generic-str.all") }}</span>
                    </label>
                  </div>
                </li>
              </ul>
              <ul v-for="(keyword, i) in keywords" :key="keyword.id" class="list-unstyled mb-3 list-options">
                <li>
                  <div class="control-group opt-2">
                    <label class="control control-checkbox" :for="'keyword-check' + i">
                      <input v-model="selectedKeywords" :id="'keyword-check' + i" :value="keyword" type="checkbox" />
                      <div class="control_indicator"></div>
                      <span>{{ keyword.word }}</span>
                    </label>
                    <dropdown>
                      <template v-slot:text>
                        <span class="material-symbols-outlined title" style="">more_horiz</span>
                      </template>
                      <template #items>
                        <!-- Editar -->
                        <button class="dropdown-item" @click="showEditKeywords(keyword.id)">
                          {{ $t("generic-str.edit") }}
                        </button>
                        <!-- Remover -->
                        <button class="dropdown-item" @click="remove(keyword)">
                          {{ $t("generic-str.remove") }}
                        </button>
                      </template>
                    </dropdown>
                  </div>
                </li>
              </ul>
            </div>
            <pagination :lastPage="pages" @change="fetch" />
          </div>
          <!-- <div v-else class="qt-block-ui relative" style="padding: 120px" /> -->
          <div class="loading min-h-300" v-else>
            <LoadingAnim />
          </div>
        </div>
      </div>
    </CardComponent>

    <!-- Sidebar - Keywords -->
    <SidebarComponent ref="kewywords" :title="$t('generic-str.status.lbl-new')" backdrop>
      <form @submit.prevent="save">
        <div class="modal-body">
          <div class="form-body">
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{ $t('key-word-component.label') }}</label>
              <div class="col-md-12">
                <textarea v-model="form.word" type="text" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending" type="submit"
            class="btn btn-yup-purple">
            {{ $t("generic-str.save") }}
          </button>
          <button type="button" class="btn btn-yup-purple-outline" @click="hide">
            {{ $t("generic-str.cancel") }}
          </button>
        </div>
      </form>
    </SidebarComponent>
    <!-- Sidebar - Edit Keywords -->
    <SidebarComponent ref="kewywordsEdit" :title="$t('generic-str.edit')" backdrop>
      <form @submit.prevent="saveEdit">
        <div class="modal-body">
          <div class="form-body">
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{ $t('key-word-component.label') }}</label>
              <div class="col-md-12">
                <textarea v-model="data.word" type="text" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hideEdit">
            {{ $t('generic-str.cancel') }}
          </button>
          <button :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending" type="submit"
            class="btn btn-primary">
            {{ $t('generic-str.save') }}
          </button>
        </div>
      </form>
    </SidebarComponent>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SmsService from '@/services/sms.service';
import Pagination from '@/components/rebranding/Pagination.vue';
import Dropdown from '@/components/Dropdown.vue';
import LottieAnimNoData from '@/components/rebranding/animLottie/NoData.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';
import CardComponent from '@/components/CardComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import { hide } from '@popperjs/core';

export default {
  name: 'KeywordsTable',
  components: {
    Pagination,
    Dropdown,
    LottieAnimNoData,
    LoadingAnim,
    CardComponent,
    SidebarComponent,
  },
  data() {
    return {
      fetched: false,
      isSending: false,
      paginate: {},
      keywords: [],
      selectedKeywords: [],
      form: {
        page: 1,
      },
      pages: 1,
      data: {
        id: null,
        word: '',
      },
    };
  },
  computed: {
    selectAllKeywords: {
      get() {
        if (this.keywords) {
          return this.selectedKeywords.length === this.keywords.length;
        }
        return false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.keywords.forEach((keyword) => {
            selected.push(keyword);
          });
        }

        this.selectedKeywords = selected;
      },
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    this.$root.$on('KeyWordsReload', () => {
      // your code goes here
      this.fetch();
    });
  },
  methods: {
    fetch(page = 1) {
      this.fetched = false;
      SmsService.getKeylist({}, page)
        .then(
          (response) => {
            this.keywords = response.data;
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetched = true;
        });
    },
    remove(keyword) {
      Swal.fire({
        title: `Remover palavra-chave "${keyword.word}"`,
        text: 'Essa ação não poderá ser desfeita',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          SmsService.deleteKeyword(keyword.id).then(
            () => {
              this.$modal.hide('dialog'); // Fecha o dialog após a execução do handler.
              this.fetch();
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: 'Palavra-chave removida com sucesso!',
                type: 'success',
              });
            },
            (error) => {
              this.content = error;
            },
          );
        }
      });
    },
    deleteMultiple() {
      Swal.fire({
        title: 'Remover palavras-chave?',
        text: 'Essa ação não poderá ser desfeita?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          const toDelete = [];
          this.selectedKeywords.forEach((item) => {
            toDelete.push(item.id);
          });
          this.isSending = true;
          SmsService.deleteMultipleKeywords({ ids: toDelete }).then(
            () => {
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('warnings.optouts.removed-number'),
                type: 'success',
              });
              this.fetch();
              this.isSending = false;
              this.selectedKeywords = [];
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
                content: error.response.data.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        }
      });
    },
    showKeywords() {
      this.$refs.kewywords.toggle();
    },
    showEditKeywords(id) {
      const itemToEdit = this.keywords.find((item) => item.id === id);

      if (itemToEdit) {
        this.data.id = itemToEdit.id;
        this.data.word = itemToEdit.word;
      }

      this.$refs.kewywordsEdit.toggle();
    },
    hide() {
      this.$refs.kewywords.toggle();

      this.form = {
        word: '',
      };
    },
    hideEdit() {
      this.$refs.kewywordsEdit.toggle();
    },
    save() {
      this.isSending = true;
      SmsService.createKeywords({
        word: this.form.word,
        channel: 'sms',
      }).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('key-word-component.success'),
            type: 'success',
          });
          this.$emit('submit');
          this.$root.$emit('KeyWordsReload');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
    saveEdit() {
      this.isSending = true;
      SmsService.editKeyList(this.data).then(
        () => {
          this.hideEdit();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('key-word-component.update'),
            type: 'success',
          });
          this.$emit('submit');
          this.$root.$emit('KeyWordsReload');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>

<style scoped lang="scss">
.table-responsive {
  overflow-x: visible !important;
}

@media (min-width: 768px) and (max-width: 992px) {
  .btn-trim {
    display: none;
  }
}

.card-body {
  min-height: 200px !important;
}

.table-responsive {
  min-height: 300px;
}

.btn i {
  line-height: 1;
  color: inherit;
}

.table-placeholder {
  margin-top: 25px;
}

.table-placeholder h5 {
  color: black !important;
}

.table-placeholder p {
  font-size: 13px;
}

.no-item {
  font-size: 60px;
}

/* Rebranding */
.eye_icon {
  color: #bfc5cb;
}

.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }

  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }

  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }

  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .icon_btn {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    span {
      color: var(--gray-font-color);
    }
  }
}

/* .darkmode .rebranding .form-control,
.rebranding .form-control {
  border-right: unset !important;
} */
.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}

.header_options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header_options .input-group>input,
.header_options .input-group button {
  height: 50px;
}

.rebranding .add_person {
  cursor: pointer;
}

.rebranding .opts_card button {
  height: fit-content;
  padding: 0;
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

/* Keyword */
.list-options li {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.list-options li .control-group {
  display: flex;
  gap: 10px;
  clear: both;
  width: 100%;
}

.list-options li .control-group .control {
  width: 100%;
}

.msg-optout {
  .control {
    display: flex;
    align-items: center;
  }

  .list-options span {
    font-weight: 400;
  }

  .list-options li .control-group .control {
    width: auto;
  }
}

.list-options li .control-group .control_indicator {
  float: left;
  margin-right: 10px;
}

.rebranding .purple-add {
  background-color: var(--clr-yup-purple);
  color: #fff !important;
  transition: 0.5s;
}

.rebranding .purple-add:hover {
  background-color: var(--clr-yup-purple-hover);
}

.rebranding .card {
  height: calc(100% - 1.875rem);
}

.keyword-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  textarea {
    resize: none;
  }
}

.card-header {
  padding-bottom: 0;
  border-bottom: none !important;
  display: flex;
}

.card-header .card-title {
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
}

.header_title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rebranding .card .card-header .header_title,
.rebranding .header_title {
  font-weight: 400;
}

@media screen and(max-width: 960px) {

  .rebranding .card .card-header {
  flex-direction: row;
}
}
</style>
